import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

import { DialogService } from 'primeng/dynamicdialog';

import { DateService, HelperService, HTTPService } from 'app/services';
import { config, purchaseOrderStatuses, purchaseOrderItemTypes, serviceAuthConsts, pricing } from 'app/constants';
import { datetimeFormat } from 'app/constants/date-time-format';
import { GroupDatePickerDialogComponent } from 'app/modules/shared/components';
import { Router } from '@angular/router';

@Component({
  selector: 'app-list-filter',
  templateUrl: './list-filter.component.html',
  styleUrls: ['./list-filter.component.scss'],
})
export class ListFilterComponent implements OnInit {
  @Input() type: string = '';
  @Input() genericFilterOptions: any = {
    iconClass: '',
    nameField: 'name',
    selectAllText: 'All',
    multipleSelectText: '',
    styleCss: {},
    filterOverlayStyle: {},
  };

  @Input('preAppliedFilter')
  set setPreAppliedFilter(filter: any) {
    if (!filter) return;

    const { multiROcreatedDate = {}, multiInvDate = {}, date = {}, roCreateAtFilterOption = {}, invoiceDateFilterOption = {}, multiRangeRODate = {}, multiRangeInvDate = {}, tireStorageSeasonality = {} } = filter;

    if (filter.customerFleet?.regular || filter.customerFleet?.fleet) {
      this.filterApplied.customerFleet = true;
      if(filter.customerFleet.regular) this.filter.customerFleet.regular = true;
      if(filter.customerFleet.fleet) this.filter.customerFleet.fleet = true;
    }

    if(filter.language) {
      if (filter.language.en) this.filter.language.en = filter.language.en;
      if (filter.language.fr) this.filter.language.fr = filter.language.fr;
    }

    if(filter.tags && filter.tags?.selected?.length) {
      this.filter.tags = filter.tags;
    }

    if(filter.serviceAuthStatus && filter.serviceAuthStatus?.selected?.length) {
      this.filter.serviceAuthStatus = filter.serviceAuthStatus;
    }

    if(filter.serviceCategories && filter.serviceCategories?.selected?.length) {
      this.filter.serviceCategories = filter.serviceCategories;
    }

    if (date.startDate && date.endDate) {
      this.filterTitle.dayFilterOption = date.filterTitle;
      this.filterApplied.dayFilterOption = true;
    }

    if (date.startDate && date.endDate) {
      this.filterTitle.serviceDate = date.filterTitle;
      this.filterApplied.serviceDate = true;
    }

    if (roCreateAtFilterOption.startDate && roCreateAtFilterOption.endDate) {
      this.filterTitle.roCreateAtFilterOption = roCreateAtFilterOption.filterTitle;
      this.filterApplied.roCreateAtFilterOption = true;
    }

    if (multiRangeRODate?.startDate?.id && multiRangeRODate?.endDate?.id) {
      this.filterApplied.multiRangeRODate = true;
      this.filter.multiRangeRODate = filter.multiRangeRODate;
    }

    if (multiRangeInvDate?.startDate?.id && multiRangeInvDate?.endDate?.id) {
      this.filterApplied.multiRangeInvDate = true;
      this.filter.multiRangeInvDate = filter.multiRangeInvDate;
    }

    if (invoiceDateFilterOption.startDate && invoiceDateFilterOption.endDate) {
      this.filterTitle.invoiceDateFilterOption = invoiceDateFilterOption.filterTitle;
      this.filterApplied.invoiceDateFilterOption = true;
    }

    if (multiInvDate.selected && multiInvDate.selected.length) {
      this.multiInvoiceDateFilterOption.forEach((item) => {
        const found = multiInvDate.selected.find((selectedItem) => selectedItem.id === item.id);
        if (found) {
          item.isChecked = true;
        }
      });

      this.filter.multiInvDate = filter.multiInvDate;
    }
    if (multiROcreatedDate.selected && multiROcreatedDate.selected.length) {
      this.multiRODateFilterOption.forEach((item) => {
        const found = multiROcreatedDate.selected.find((selectedItem) => selectedItem.id === item.id);
        if (found) {
          item.isChecked = true;
        }
      });
    }
    if (tireStorageSeasonality.summer || tireStorageSeasonality.winter) {
      if(tireStorageSeasonality.summer) this.filter.tireStorageSeasonality.summer = true;
      if(tireStorageSeasonality.winter) this.filter.tireStorageSeasonality.winter = true;
    }

    this.whichFilterApplied('status');
    this.whichFilterApplied('tags');
    this.whichFilterApplied('tenantFeature');
    this.whichFilterApplied('tenantBetaFlagFeature');
    this.whichFilterApplied('serviceCategories');
    this.whichFilterApplied('authorization');
    this.whichFilterApplied('serviceAuthStatus');
    this.whichFilterApplied('roCreateAtFilterOption');
    this.whichFilterApplied('invoiceDateFilterOption');
    this.whichFilterApplied('invoiceDateFilterOption');
    this.whichFilterApplied('tireStoragestatus');
    this.whichFilterApplied('tireStorageSeasonality');
    this.whichFilterApplied('multiInvDate');
    this.whichFilterApplied('multiROcreatedDate');
    this.whichFilterApplied('multiRangeRODate');
    this.whichFilterApplied('multiRangeInvDate');
  }
  @Input('coreSuppliers')
  set coreSuppliers(filter: any) {
    this.suppliers = filter;
    this.isCoreSuppliers = true;
  }
  @Input() childData: boolean = false;
  @Input() dateTitle: any = 'Today';
  @Input() featureList: any[] = [];
  @Input() betaList: any[] = [];
  @Input() suppliers: any[] = [];
  @Input() columns: any[] = [];
  @Input() genericFilterData: any[] = [];
  @Input() multipleGenericFiltersKeys: any = [];
  @Input() multipleGenericFiltersObject: any = {};
  @Input() isFastlapExtraOptions: boolean = false;
  @Input() options: any = {
    searchTerms: false,
    tags: false,
    tenantFeature: false,
    tenantBetaFlagFeature: false,
    status: true,
    pricingLogs: false,
    tireStoragestatus: false,
    tireStorageSeasonality: false,
    tireStorageFilterStatus: false,
    stock: false,
    supplierStatus: false,
    appliedOn: false,
    discountType: false,
    poStatus: false,
    poItemType: false,
    supplier: false,
    columns: false,
    categoryItemType: false,
    location: false,
    preffLocations: false,
    returnPart: false,
    authorization: false,
    customerFleet: false,
    dayFilterOption: false,
    removalDateOption: 'last-week',
    storageDateOption: 'last-week',
    scheduledReturnDateOption: 'last-week',
    serviceCategories: false,
    roCreateAtFilterOption: false,
    invoiceDateFilterOption: false,
    tenantType: false,
    tenantStatus: false,
    tenantFlagStatus: false,
    returnStatus: false,
    coreStatus: false,
    coreSupplier: false,
    paymentStatus: false,
    itemType: false,
    categoryType: false,
    payableStatus: false,
    genericFilter: false,
    paymentPayableStatus: false,
    multipleGenericFilters: false,
    language: false
  };
  @Input() hasPrint = false;

  @Output() filterChange = new EventEmitter<string>();
  @Output() onPrint = new EventEmitter<any>();


  @ViewChild('searchTermInput')
  searchTermInput: ElementRef;

  @Input() isTireStorage2Enabled: boolean;
  serviceCategories: any[] = [];
  selectAllPrefLocation: any = [{ name: 'Select All', isChecked: false, label: 'selectAll' }];
  defaultServiceCategories: any[] = [];
  defalutTags: any[] = [];
  defalutTenantFeature: any[] = [];
  defalutTenantBetaFeature: any[] = [];
  tags: any[] = [];
  tenantFeature: any[] = [];
  tenantBetaFlagFeature: any[] = [];
  locations: any[] = [];
  preffLocations: any[] = [];
  defaultLocations: any[] = [];
  filterApplied = {
    tenantFlagStatus: false,
    searchTerms: false,
    tags: false,
    vehicleTags: false,
    tenantFeature: false,
    tenantBetaFlagFeature: false,
    status: true,
    pricingLogs: false,
    tireStoragestatus: false,
    tireStorageFilterStatus: false,
    tireStorageSeasonality: false,
    stock: false,
    supplierStatus: false,
    appliedOn: false,
    discountType: false,
    poType: false,
    location: false,
    preffLocations: false,
    poStatus: false,
    poItemType: false,
    supplier: false,
    columns: false,
    returnPart: false,
    restockLevel: false,
    customerFleet: false,
    authorization: false,
    dayFilterOption: false,
    removalDateOption: 'All time',
    storageDateOption: 'All time',
    scheduledReturnDateOption: 'All time',
    serviceAuthStatus: false,
    serviceDate: false,
    multiInvDate: false,
    multiROcreatedDate: false,
    multiRangeInvDate: false,
    multiRangeRODate: false,
    serviceCategories: false,
    roCreateAtFilterOption: false,
    invoiceDateFilterOption: false,
    tenantType: false,
    tenantStatus: false,
    returnStatus: false,
    coreStatus: false,
    coreSupplier: false,
    paymentStatus: false,
    itemType: false,
    categoryType: false,
    categoryItemType: false,
    payableStatus: false,
    genericFilter: false,
    paymentPayableStatus: false,
    language: false
  };
  filter: any = {
    language: {
      en: false,
      fr: false
    },
    searchTerms: {
      selected: [],
    },
    tags: {
      selected: [],
    },
    customerFleet: {
      fleet: false,
      regular: false,
    },
    status: {
      active: true,
      inActive: false,
    },
    pricingLogs: {
      company: false,
      matrix: false,
    },
    tireStoragestatus: {
      inStorage: false,
      returned: false,
    },
    tireStorageFilterStatus: {
      inStorage: false,
      removed: false,
    },
    tireStorageSeasonality: {
      summer: false,
      winter: false,
    },
    location: {
      selected: [],
    },
    preffLocations: {
      selected: [],
    },
    serviceCategories: {
      selected: [],
    },
    serviceAuthStatus: {
      selected: [],
    },
    multiInvDate: {
      selected: [],
    },
    multiROcreatedDate: {
      selected: [],
    },
    multiRangeInvDate: {
      startDate: null,
      endDate: null,
    },
    multiRangeRODate: {
      startDate: null,
      endDate: null,
    },
    stock: {
      active: false,
      inActive: false,
    },
    supplierStatus: {
      internal: false,
      online: false,
    },
    appliedOn: {
      orderLevel: false,
      serviceLevel: false,
    },
    discountType: {
      percentage: false,
      dollarValue: false,
    },
    poType: {
      active: false,
      inActive: false,
    },
    restockLevel: {
      active: false,
      inActive: false,
    },
    poStatus: null,
    poItemType: null,
    paymentStatus: null,
    itemType: null,
    categoryItemType: null,
    categoryType: null,
    payableStatus: null,
    paymentPayableStatus: null,
    returnPart: null,
    supplier: {
      selected: [],
    },
    columns: {
      selected: [],
    },
    date: {
      startDate: null,
      endDate: null,
    },
    serviceDate: {
      startDate: null,
      endDate: null,
    },
    removalDateOption: {
      startDate: null,
      endDate: null,
      filterTitle: '',
    },
    storageDateOption: {
      startDate: null,
      endDate: null,
      filterTitle: '',
    },
    scheduledReturnDateOption: {
      startDate: null,
      endDate: null,
      filterTitle: '',
    },
    invoiceDateFilterOption: {
      startDate: null,
      endDate: null,
    },
    roCreateAtFilterOption: {
      startDate: null,
      endDate: null,
    },
    authorization: {
      approved: false,
      notApproved: false,
    },
    coreStatus: {
      selected: [],
    },
    returnStatus: {
      selected: [],
    },
    coreSupplier: null,
    tenantTypeSelected: [],
    tenantFeatureSelected: [],
    tenantBetaFeatureSelected: [],
    tenantStatusSelected: [],
    tenantFlagStatusSelected: [],
    genericFilter: {
      selected: [],
    },
  };

  featureFilter = {
    tenantType: {
      DEMO: false,
      PDQ: false,
      PROD: false,
      SANDBOX: false,
    },
    tenantStatus: {
      LIVE: false,
      UNLIVE: false,
      DELETE: false,
    },
    tenantFlagStatus: {
      BETA: false,
      FEATURE: false,
    },
    tenantFeature: {
      selected: [],
    },
    tenantBetaFlagFeature: {
      selected: [],
    },
  };
  dateFilterOption: any = [
    { id: 'today', title: 'Today' },
    { id: 'yesterday', title: 'Yesterday' },
    { id: 'this-week', title: 'This week' },
    { id: 'last-week', title: 'Last week' },
    { id: 'this-month', title: 'This month' },
    { id: 'last-month', title: 'Last month' },
    { id: 'year-to-date', title: 'Year to date' },
    { id: 'all-time', title: 'All time' },
    { id: 'custom', title: 'Custom' },
  ];
  filterTitle = {
    tags: {
      all: 'Customer tags',
      multiple: 'Multiple tags',
    },
    lanugage: {
      en: "Langugage: English",
      fr: "Language: French"
    },
    customerFleet: {
      all: 'Customer Type',
      fleet: 'Fleet',
      regular: 'Regular',
    },
    tenantFeature: {
      allSelected: 'Feature Flags: All',
      all: 'Feature Flags',
      multiple: 'Features Flags: Multiple',
    },
    tenantBetaFlagFeature: {
      allSelected: 'Beta Flags: All',
      all: 'Beta Flags',
      multiple: 'Beta Flags: Multiple',
    },
    tenantType: {
      // all other constants
      all: 'Tenant type',
      multiple: 'Tenant Type: Multiple',
      DEMO: 'Demo',
      PDQ: 'PDQ',
      PROD: 'Prod',
      SANDBOX: 'Sandbox',
    },
    tenantStatus: {
      // all other constants
      all: 'Tenant status',
      multiple: 'Tenant status: Multiple',
      LIVE: 'Live',
      UNLIVE: 'Unlive',
      DELETE: 'Delete',
    },
    tenantFlagStatus: {
      // all other constants
      all: 'Beta Flags:',
      BETA: 'Beta Flags',
      FEATURE: 'Feature Flags',
    },
    status: {
      all: 'All',
      active: 'Active',
      inActive: 'Inactive',
    },
    pricingLogs: {
      all: 'All',
      company: 'Company',
      matrix: 'Matrix edits',
    },
    tireStoragestatus: {
      all: 'Status',
      inStorage: 'In Storage',
      returned: 'Returned',
    },
    tireStorageFilterStatus: {
      all: 'Status',
      inStorage: 'In Storage',
      removed: 'Removed',
    },
    tireStorageSeasonality: {
      all: 'All Season',
      summer: 'Summer',
      winter: 'Winter',
    },
    location: {
      all: 'Locations',
      multiple: 'Multiple Locations',
    },
    preffLocations: {
      all: 'Preferred  locations',
      multiple: 'Multiple Preferred locations',
    },
    serviceAuthStatus: {
      all: 'Authorization status',
      multiple: 'Multiple authorization status',
    },
    multiInvDate: {
      all: 'Last RO invoiced',
      multiple: 'Multiple INV-RO invoice date',
    },
    multiROcreatedDate: {
      all: 'Last RO created',
      multiple: 'Multiple RO-RO created date',
    },
    serviceCategories: {
      all: 'Categories',
      multiple: 'Multiple Categories',
    },
    stock: {
      all: 'All',
      active: 'Stock',
      inActive: 'Non-stock',
    },
    supplierStatus: {
      all: 'Supplier type',
      internal: 'Internal',
      online: 'Online ordering',
    },
    appliedOn: {
      all: 'Applied On',
      orderLevel: 'Order Level',
      serviceLevel: 'Service Level',
    },
    discountType: {
      all: 'Discount type',
      percentage: 'Percentage',
      dollarValue: 'Dollar Value',
    },
    categoryItemType: {
      all: 'All',
      part: 'Parts',
      labor: 'Labor',
      tire: 'Tire',
      hazmatFee: 'Fees',
      discount: 'Discount',
    },
    poStatus: {
      all: 'All',
      draft: 'Draft',
      ordered: 'Ordered',
      received: 'Received',
      cancelled: 'Cancelled',
    },
    poItemType: {
      inventory: 'Inventory',
      nonInventory: 'Non Inventory',
    },
    paymentStatus: {
      all: 'All',
      unpaid: 'Unpaid',
      paid: 'Paid',
      partial: 'Partially paid',
    },
    itemType: {
      all: 'All',
      part: 'Parts',
      labor: 'Labor',
      tire: 'Tire',
      hazmatFee: 'Fees',
      discount: 'Discount',
    },
    categoryType: {
      all: 'All',
      sales: 'Sales',
      product: 'Product',
    },
    payableStatus: {
      all: 'All',
      due: 'Due',
      notDue: 'Not Due',
    },
    paymentPayableStatus: {
      all: 'All',
      unpaid: 'Unpaid',
      paid: 'Paid',
      partial: 'Partially paid',
      due: 'Due',
      notDue: 'Not Due',
    },
    returnPart: {
      shipped: 'Shipped',
      delivered: 'Delivered',
      refunded: 'Refunded',
    },
    supplier: {
      all: 'All',
      multiple: 'Multiple supplier',
    },
    columns: {
      all: 'All',
      multiple: 'Multiple',
    },
    poType: {
      all: 'Type',
      active: 'Part',
      inActive: 'Tire',
    },
    restockLevel: {
      all: 'Restock level',
      active: 'Above',
      inActive: 'Below',
    },
    authorization: {
      all: 'Authorization',
      approved: 'Approved',
      notApproved: 'Not Approved',
    },
    coreStatusList: {
      toBeRetrieved: 'To be retrieved',
      damaged: 'Damaged',
      retrieved: 'Retrieved',
      multiple: 'Multiple core',
    },
    returnStatusList: {
      toBeRetrieved: 'To be retrieved',
      damaged: 'Damaged',
      multiple: 'Multiple return',
      markedForReturn: 'Marked for return',
      shipped: 'Shipped',
      refunded: 'Refunded',
      delivered: 'Delivered',
    },
    dayFilterOption: 'Service date',
    serviceDate: 'Service date',
    invoiceDateFilterOption: 'RO invoice date',
    roCreateAtFilterOption: 'RO created date',
    removalDateOption: 'All time',
    storageDateOption: 'All time',
    scheduledReturnDateOption: 'All time',
    genericFilter: {
      all: 'All',
      multiple: 'Multiple',
    },
  };
  categoryItemTypeDropDownList: any = [
    { label: 'Labor', value: 'labor', statusActive: false },
    { label: 'Fees', value: 'hazmatFee', statusActive: false },
    { label: 'Discount', value: 'discount', statusActive: false },
  ];
  multiRODateFilterOption: any = [
    { id: 30, name: 'Last 30 days', range: '0-30' },
    { id: 60, name: '30 -60 days', range: '30-60' },
    { id: 90, name: '60 - 90 days', range: '60-90' },
    { id: 180, name: '90 - 180 days', range: '90 - 180' },
    { id: 270, name: '180 - 270 days', range: '180 - 270' },
    { id: 365, name: ' 270 - 365 days', range: ' 270 - 365' },
    { id: 0, name: '1+ year', range: '365' },
  ];

  multiRangeRODateFilterOption: any = {
    startDate: [
      { id: 0, name: '0 days', range: '0-30', isInActive: false },
      { id: 30, name: '30 days', range: '30-60', isInActive: false },
      { id: 60, name: '60 days', range: '60-90', isInActive: false },
      { id: 90, name: '90 days', range: '90 - 180', isInActive: false },
      { id: 180, name: '180 days', range: '180 - 270', isInActive: false },
      { id: 270, name: ' 270 days', range: ' 270 - 365', isInActive: false },
      { id: 365, name: '1 Year', range: '365', isInActive: false },
      { id: 730, name: '2 Year', range: '365 - 730', isInActive: false },
      { id: 1095, name: '3 Year', range: '730 - 1095', isInActive: false },
      { id: 1460, name: '4 Year', range: '1095 - 1460', isInActive: false },
    ],
    endDate: [
      { id: 30, name: '30 days', range: '30-60', isInActive: false },
      { id: 60, name: '60 days', range: '60-90', isInActive: false },
      { id: 90, name: '90 days', range: '90 - 180', isInActive: false },
      { id: 180, name: '180 days', range: '180 - 270', isInActive: false },
      { id: 270, name: ' 270 days', range: ' 270 - 365', isInActive: false },
      { id: 365, name: '1 Year', range: '365', isInActive: false },
      { id: 730, name: '2 Year', range: '365 - 730', isInActive: false },
      { id: 1095, name: '3 Year', range: '730 - 1095', isInActive: false },
      { id: 1460, name: '4 Year', range: '1095 - 1460', isInActive: false },
      { id: 1825, name: '5 Year', range: '1825', isInActive: false },
    ],
  };

  multiRangeInvDateFilterOption: any = {
    startDate: [
      { id: 0, name: '0 days', range: '0-30', isInActive: false },
      { id: 30, name: '30 days', range: '30-60', isInActive: false },
      { id: 60, name: '60 days', range: '60-90', isInActive: false },
      { id: 90, name: '90 days', range: '90 - 180', isInActive: false },
      { id: 180, name: '180 days', range: '180 - 270', isInActive: false },
      { id: 270, name: ' 270 days', range: ' 270 - 365', isInActive: false },
      { id: 365, name: '1 Year', range: '365', isInActive: false },
      { id: 730, name: '2 Year', range: '365 - 730', isInActive: false },
      { id: 1095, name: '3 Year', range: '730 - 1095', isInActive: false },
      { id: 1460, name: '4 Year', range: '1095 - 1460', isInActive: false },
    ],
    endDate: [
      { id: 30, name: '30 days', range: '30-60', isInActive: false },
      { id: 60, name: '60 days', range: '60-90', isInActive: false },
      { id: 90, name: '90 days', range: '90 - 180', isInActive: false },
      { id: 180, name: '180 days', range: '180 - 270', isInActive: false },
      { id: 270, name: ' 270 days', range: ' 270 - 365', isInActive: false },
      { id: 365, name: '1 Year', range: '365', isInActive: false },
      { id: 730, name: '2 Year', range: '365 - 730', isInActive: false },
      { id: 1095, name: '3 Year', range: '730 - 1095', isInActive: false },
      { id: 1460, name: '4 Year', range: '1095 - 1460', isInActive: false },
      { id: 1825, name: '5 Year', range: '1825', isInActive: false },
    ],
  };

  coreList: any = [
    { value: 'toBeRetrieved', name: 'To be retrieved' },
    { value: 'damaged', name: 'Damaged' },
    { value: 'retrieved', name: 'Retrieved' },
  ];

  multiInvoiceDateFilterOption: any = [
    { id: 30, name: 'Last 30 days', range: '0-30' },
    { id: 60, name: '30 -60 days', range: '30-60' },
    { id: 90, name: '60 - 90 days', range: '60-90' },
    { id: 180, name: '90 - 180 days', range: '90 - 180' },
    { id: 270, name: '180 - 270 days', range: '180 - 270' },
    { id: 365, name: ' 270 - 365 days', range: ' 270 - 365' },
    { id: 0, name: '1+ year', range: '365' },
  ];

  paymentStatusDropDownList: any = [
    { value: 'unpaid', label: 'Unpaid', statusActive: false },
    { value: 'paid', label: 'Paid', statusActive: false },
    { value: 'partial', label: 'Partially paid', statusActive: false },
  ];

  itemTypeDropDownList: any = [
    { label: 'Part', value: 'part', statusActive: false },
    { label: 'Tire', value: 'tire', statusActive: false },
    { label: 'Labor', value: 'labor', statusActive: false },
    { label: 'Fees', value: 'hazmatFee', statusActive: false },
    { label: 'Discount', value: 'discount', statusActive: false },
  ];

  categoryTypeDropDownList: any = [
    { label: 'Product', value: 'product', statusActive: false },
    { label: 'Sales', value: 'sales', statusActive: false },
  ];

  payableStatusDropDownList: any = [
    { value: 'due', label: 'Due', statusActive: false },
    { value: 'notDue', label: 'Not Due', statusActive: false },
  ];
  paymentPayableStatusDropDownList: any = [
    { value: 'unpaid', label: 'Unpaid', statusActive: false },
    { value: 'paid', label: 'Paid', statusActive: false },
    { value: 'partial', label: 'Partially paid', statusActive: false },
    { value: 'due', label: 'Due', statusActive: false },
    { value: 'notDue', label: 'Not Due', statusActive: false },
  ];
  returnList: any = [
    { value: 'toBeRetrieved', name: 'To be retrieved' },
    { value: 'damaged', name: 'Damaged' },
    { value: 'shipped', name: 'Shipped' },
    { value: 'delivered', name: 'Delivered' },
    { value: 'markedReturn', name: 'Marked for return' },
    { value: 'refunded', name: 'Refunded' },
  ];
  dayFilterOption: any = [
    { id: 30, title: 'Last 30 days', startDate: null, endDate: null },
    { id: 60, title: '30 -60 days', startDate: null, endDate: null },
    { id: 90, title: '60 - 90 days', startDate: null, endDate: null },
    { id: 180, title: '90 - 180 days', startDate: null, endDate: null },
    { id: 270, title: '180 - 270 days', startDate: null, endDate: null },
    { id: 365, title: ' 270 - 365 days', startDate: null, endDate: null },
    { id: 0, title: '1+ year', startDate: null, endDate: null },
  ];
  invoiceDateFilterOption: any = [
    { id: 30, title: 'Last 30 days', range: '0-30' },
    { id: 60, title: '30 -60 days', range: '30-60' },
    { id: 90, title: '60 - 90 days', range: '60-90' },
    { id: 180, title: '90 - 180 days', range: '90 - 180' },
    { id: 270, title: '180 - 270 days', range: '180 - 270' },
    { id: 365, title: ' 270 - 365 days', range: ' 270 - 365' },
    { id: 0, title: '1+ year', range: '365' },
  ];
  roCreateAtFilterOption: any = [
    { id: 30, title: 'Last 30 days', range: '0-30' },
    { id: 60, title: '30 -60 days', range: '30-60' },
    { id: 90, title: '60 - 90 days', range: '60-90' },
    { id: 180, title: '90 - 180 days', range: '90 - 180' },
    { id: 270, title: '180 - 270 days', range: '180 - 270' },
    { id: 365, title: ' 270 - 365 days', range: ' 270 - 365' },
    { id: 0, title: '1+ year', range: '365' },
  ];
  serviceAuthOption: any = [
    { value: serviceAuthConsts.pending, name: 'Pending' },
    { value: serviceAuthConsts.approved, name: 'Approved' },
    { value: serviceAuthConsts.deferred, name: 'Deferred' },
    { value: serviceAuthConsts.declined, name: 'Declined' },
  ];
  momentPeriod = {
    day: 'days',
    week: 'weeks',
    month: 'months',
  };
  defaultFilter = this.helperService.deepCopy(this.filter);
  closeAfterAction: boolean = false;
  purchaseOrderStatuses: any = this.helperService.deepCopy(purchaseOrderStatuses);
  purchaseOrderItemTypes: any = this.helperService.deepCopy(purchaseOrderItemTypes);
  searchTermText: string = '';
  featureFlag = [];
  betaFlag = [];
  isCoreSuppliers: boolean = false;
  currentDateTime;
  constructor(
    private helperService: HelperService,
    private httpService: HTTPService,
    public dateService: DateService,
    private dialogService: DialogService,
    private router: Router,
    
  ) {}

  async ngOnInit() {
    this.filterTitle.status.all = `All ${this.type}`;
    // this.filterTitle.tireStoragestatus.all = `All ${this.type}`;

    if (this.options.childData) {
      let marketingList = [
        {
          field: 'isMarketingPaid',
          isChecked: false,
          header: 'Marketing Paid',
        },
        {
          field: 'isMarketingTrial',
          isChecked: false,
          header: 'Marketing Trial',
        },
      ];
      this.featureList = [...marketingList, ...this.featureList];
      this.betaList = [...this.betaList];

      this.featureList.sort(function (a, b) {
        var a = a.header,
          b = b.header;
        if (a < b) return -1;
        if (a > b) return 1;
        return 0;
      });
    }

    if(this.isTireStorage2Enabled){
      if(this.options.storageDateOption)this.filter.storageDateOption.dateTitle = 'All time';
      if(this.options.removalDateOption)this.filter.removalDateOption.dateTitle = 'All time';
      if(this.options.scheduledReturnDateOption)this.filter.scheduledReturnDateOption.dateTitle = 'All time';

      this.dateFilterOption = [
        { id: 'today', title: 'Today' },
        this.options.scheduledReturnDateOption ? { id: 'tomorrow', title: 'Tomorrow' } : { id: 'yesterday', title: 'Yesterday' },
        { id: 'this-week', title: 'This week' },
        this.options.scheduledReturnDateOption ? { id: 'next-week', title: 'Next week' } : { id: 'last-week', title: 'Last week' },
        { id: 'this-month', title: 'This month' },
        this.options.scheduledReturnDateOption ? { id: 'next-month', title: 'Next month' } : { id: 'last-month', title: 'Last month' },
        { id: 'year-to-date', title: 'Year to date' },
        { id: 'all-time', title: 'All time' },
        { id: 'custom', title: 'Custom' },
      ];
    }

    // if (this.isFastlapExtraOptions) {
    //   this.multiInvoiceDateFilterOption.splice(findIndex(this.multiInvoiceDateFilterOption, { id: 0 }), 1);
    //   this.multiInvoiceDateFilterOption.push(
    //     { id: 730, name: '1-2 year', range: '365 - 730' },
    //     { id: 1095, name: '2-3 year', range: '730 - 1095' },
    //     { id: 1460, name: '3-4 year', range: '1095 - 1460' },
    //     { id: 0, name: '4 year+', range: '1460' },
    //   );

    //   this.multiRODateFilterOption.splice(findIndex(this.multiRODateFilterOption, { id: 0 }), 1);
    //   this.multiRODateFilterOption.push(
    //     { id: 730, name: '1-2 year', range: '365 - 730' },
    //     { id: 1095, name: '2-3 year', range: '730 - 1095' },
    //     { id: 1460, name: '3-4 year', range: '1095 - 1460' },
    //     { id: 0, name: '4 year+', range: '1460' },
    //   );
    // }

    this.featureFlag = this.featureList.map(({ field, header }) => ({ field, name: header }));
    this.betaFlag = this.betaList.map(({ field, header }) => ({ field, name: header }));

    if (this.options.tags) {
      this.getTags(config.tags.customer);
    }

    if (this.options.categoryItemType) {
      this.changeTagFilter('categoryItemType', 'labor', false);
    }

    if (this.options.tenantFeature) {
      this.featureFlag = this.featureFlag.map((ff) => {
        ff['isChecked'] = false;
        return ff;
      });

      this.tenantFeature = this.featureFlag.sort((a, b) => (a.name > b.name ? 1 : -1));
      this.defalutTenantFeature = this.helperService.deepCopy(this.tenantFeature);
    }

    if (this.options.tenantBetaFlagFeature) {
      this.betaFlag = this.betaFlag.map((ff) => {
        ff['isChecked'] = false;
        return ff;
      });
      this.tenantBetaFlagFeature = this.betaFlag.sort((a, b) => (a.name > b.name ? 1 : -1));
      this.defalutTenantBetaFeature = this.helperService.deepCopy(this.tenantBetaFlagFeature);
    }
    // this.filter.storageDateOption.startDate = this.dateService.formatDate(new Date(), datetimeFormat.yyymmdd);
    // this.filter.storageDateOption.endDate = this.dateService.formatDate(new Date(), datetimeFormat.yyymmdd);

    // this.filter.removalDateOption.startDate = this.dateService.formatDate(new Date(), datetimeFormat.yyymmdd);
    // this.filter.removalDateOption.endDate = this.dateService.formatDate(new Date(), datetimeFormat.yyymmdd);
    // this.dateTitle = this.dateService.formatDateRange(this.filter.removalDateOption.startDate, this.filter.removalDateOption.endDate);

    this.currentDateTime = await this.httpService.getServerTime();

    if (this.options.location) {
      this.getLocations();
    }

    if (this.options.preffLocations) {
      this.getPreffredLocation();
    }

    if (this.options.serviceCategories) {
      this.getServiceCategories();
    }

    if (this.options.isItemReturnType) {
      this.returnList = [
        { value: 'shipped', name: 'Shipped' },
        { value: 'delivered', name: 'Delivered' },
        { value: 'refunded', name: 'Refunded' },
        { value: 'markedForReturn', name: 'Marked for Return' },
      ];
      this.returnList.map((data) => {
        if (data.value !== 'refunded') {
          data['isChecked'] = true;
          this.filter.returnStatus.selected.push(data);
        }
      });
      this.filterApplied.returnStatus = !!(this.filter.returnStatus && this.filter.returnStatus.selected && this.filter.returnStatus.selected.length);
    }
  }

  getTags(type: any) {
    this.httpService.getTags(type).then(
      (tags: any[]) => {
        if (tags.length) {
          tags = tags.map((tag) => {
            tag['isChecked'] = false;
            if (type === 'customer' && this.filter.tags.selected.length > 0) {
              this.filter.tags.selected.forEach((element) => {
                if (tag._id === element._id) tag['isChecked'] = true;
              });
            }
            return tag;
          });
          this.tags = tags.sort((a, b) => (a.name > b.name ? 1 : -1));
          this.defalutTags = this.helperService.deepCopy(this.tags);
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      },
    );
  }

  async onDateSelect(id: Number, filterType: string) {
    const currentDateTime = await this.httpService.getServerTime();

    let datetime: any = this.dateService.getCurrentDateTimeTz(Number(currentDateTime));

    if (!this.filter[filterType]) this.filter[filterType] = {};

    if (id === 30) {
      this.filter[filterType].period = '30';
      this.filter[filterType].startDate = this.dateService.subDaysInDatetime(datetime, 30, this.momentPeriod.day, datetimeFormat.yyymmdd);
      this.filter[filterType].endDate = this.dateService.formatDate(datetime, datetimeFormat.yyymmdd);
      this.filterTitle[filterType] = 'Last 30 days';
    }

    if (id === 60) {
      this.filter[filterType].period = '30-60';
      this.filter[filterType].startDate = this.dateService.subDaysInDatetime(datetime, 60, this.momentPeriod.day, datetimeFormat.yyymmdd);
      this.filter[filterType].endDate = this.dateService.subDaysInDatetime(datetime, 30, this.momentPeriod.day, datetimeFormat.yyymmdd);
      this.filterTitle[filterType] = '30 - 60 days';
    }

    if (id === 90) {
      this.filter[filterType].period = '60-90';
      this.filter[filterType].startDate = this.dateService.subDaysInDatetime(datetime, 90, this.momentPeriod.day, datetimeFormat.yyymmdd);
      this.filter[filterType].endDate = this.dateService.subDaysInDatetime(datetime, 60, this.momentPeriod.day, datetimeFormat.yyymmdd);
      this.filterTitle[filterType] = '60 - 90 days';
    }
    if (id === 180) {
      this.filter[filterType].period = '90-180';
      this.filter[filterType].startDate = this.dateService.subDaysInDatetime(datetime, 180, this.momentPeriod.day, datetimeFormat.yyymmdd);
      this.filter[filterType].endDate = this.dateService.subDaysInDatetime(datetime, 90, this.momentPeriod.day, datetimeFormat.yyymmdd);
      this.filterTitle[filterType] = '90 - 180 days';
    }
    if (id === 270) {
      this.filter[filterType].period = '180-270';
      this.filter[filterType].startDate = this.dateService.subDaysInDatetime(datetime, 270, this.momentPeriod.day, datetimeFormat.yyymmdd);
      this.filter[filterType].endDate = this.dateService.subDaysInDatetime(datetime, 180, this.momentPeriod.day, datetimeFormat.yyymmdd);
      this.filterTitle[filterType] = '180 - 270 days';
    }

    if (id === 365) {
      this.filter[filterType].period = '270-365';
      this.filter[filterType].startDate = this.dateService.subDaysInDatetime(datetime, 365, this.momentPeriod.day, datetimeFormat.yyymmdd);
      this.filter[filterType].endDate = this.dateService.subDaysInDatetime(datetime, 270, this.momentPeriod.day, datetimeFormat.yyymmdd);
      this.filterTitle[filterType] = '270 - 365 days';
    }

    if (id === 0) {
      this.filter[filterType].period = '1+year';
      this.filter[filterType].endDate = this.dateService.subDaysInDatetime(datetime, 365, this.momentPeriod.day, datetimeFormat.yyymmdd);
      this.filter[filterType].startDate = null;
      this.filterTitle[filterType] = '1+ year';
    }
    this.filter[filterType].filterTitle = this.filterTitle[filterType];
    this.closeAfterAction = !this.closeAfterAction;
    this.filterApplied[filterType] = true;
    this.filterChange.emit(this.filter);
  }

  onChange(type: string, key: string) {
    if (['customerFleet', 'authorization'].includes(type) && !this.filter[type]) {
      this.filter[type] = this.defaultFilter[type];
    }
    this.filter[type][key] = !this.filter[type][key];
    this.closeAfterAction = !this.closeAfterAction;
    this.whichFilterApplied(type);
    this.filterChange.emit(this.filter);
  }

  onChangeTenantType(type: string, key: string) {
    this.featureFilter[type][key] = !this.featureFilter[type][key];
    let keys = Object.keys(this.featureFilter.tenantType).filter((k) => this.featureFilter.tenantType[k] === true);
    this.filter.tenantTypeSelected = keys;

    this.closeAfterAction = !this.closeAfterAction;
    this.whichFilterApplied(type);
    this.filterChange.emit(this.filter);
  }

  onChangeTenantStatus(type: string, key: string) {
    this.featureFilter[type][key] = !this.featureFilter[type][key];
    let keys = Object.keys(this.featureFilter.tenantStatus).filter((k) => this.featureFilter.tenantStatus[k] === true);
    this.filter.tenantStatusSelected = keys;

    this.closeAfterAction = !this.closeAfterAction;
    this.whichFilterApplied(type);
    this.filterChange.emit(this.filter);
  }
  onChangeTenantFlagStatus(type: string, key: string) {
    this.featureFilter[type][key] = !this.featureFilter[type][key];
    let keys = Object.keys(this.featureFilter.tenantFlagStatus).filter((k) => this.featureFilter.tenantFlagStatus[k] === true);
    this.filter.tenantFlagStatusSelected = keys;

    this.closeAfterAction = !this.closeAfterAction;
    this.whichFilterApplied(type);
    this.filterChange.emit(this.filter);
  }

  changeTenantFeatureFilter(key: string, event: any, isMultiple: boolean = false) {
    if (isMultiple) {
      this.featureFilter[key].selected = this.helperService.deepCopy(event);
    } else {
      this.featureFilter[key] = event;
    }
    this.filter.tenantFeatureSelected = this.featureFilter.tenantFeature.selected.map((k) => {
      if (k.isChecked) return k.field;
    });
    this.whichFilterApplied(key);
    this.closeAfterAction = !this.closeAfterAction;
    this.filterChange.emit(this.filter);
  }

  changeTenantBetaFeatureFilter(key: string, event: any, isMultiple: boolean = false) {
    if (isMultiple) {
      this.featureFilter[key].selected = this.helperService.deepCopy(event);
    } else {
      this.featureFilter[key] = event;
    }
    this.filter.tenantBetaFeatureSelected = this.featureFilter.tenantBetaFlagFeature.selected.map((k) => {
      if (k.isChecked) return k.field;
    });
    this.whichFilterApplied(key);
    this.closeAfterAction = !this.closeAfterAction;
    this.filterChange.emit(this.filter);
  }

  changeLocationsFilter(event: any) {
    this.filter.location.selected = event;
    if(!this.isTireStorage2Enabled) this.closeAfterAction = !this.closeAfterAction;
    this.whichFilterApplied('location');
    this.filterChange.emit(this.filter);
  }

  changePreffredLocationsFilter(event: any, type) {
    if (!this.filter.preffLocations) {
      this.filter.preffLocations = { selected: [] };
    }
    if (type.label === 'selectAll') {
      if (type.isChecked) {
        this.preffLocations.map((pl) => {
          pl.isChecked = true;
        });
        this.filter.preffLocations.selected = this.preffLocations;
        this.selectAllPrefLocation[0].isChecked = true;
      } else if (!type.isChecked) {
        this.preffLocations.map((pl) => {
          pl.isChecked = false;
        });
        this.filter.preffLocations.selected = [];
        this.selectAllPrefLocation[0].isChecked = false;
      }
    } else {
      this.filter.preffLocations.selected = event;
      if (this.filter.preffLocations.selected) {
        this.selectAllPrefLocation[0].isChecked = this.filter.preffLocations.selected.length === this.preffLocations.length ? true : false;
      }
    }
    // this.closeAfterAction = !this.closeAfterAction;
    this.whichFilterApplied('preffLocations');
    this.filterChange.emit(this.filter);
  }

  changeServiceAuthFilter(event: any) {
    this.filter.serviceAuthStatus = {
      selected: event,
    };
    this.closeAfterAction = !this.closeAfterAction;
    this.whichFilterApplied('serviceAuthStatus');
    this.filterChange.emit(this.filter);
  }

  changeMultiInvDateFilter(event: any) {
    this.filter.multiInvDate = {
      selected: event,
    };
  }

  handleInvoiceDateFilter() {
    // if(this.filter.multiInvDate.selected.length){
    this.whichFilterApplied('multiInvDate');
    this.filterChange.emit(this.filter);
    this.closeAfterAction = !this.closeAfterAction;
    // }
  }

  changeMultiRODateFilter(event: any) {
    this.filter.multiROcreatedDate = {
      selected: event,
    };
  }

  handleRODateFilter() {
    if (this.filter.multiROcreatedDate.selected.length) {
      this.whichFilterApplied('multiROcreatedDate');
      this.filterChange.emit(this.filter);
      this.closeAfterAction = !this.closeAfterAction;
    }
  }

  changeMultInvRangeDateFilter(event: any, key: string, subKey: string) {
    if (!this.filter[key]) this.filter[key] = {};
    this.filter[key][subKey] = event;
    this.validateMultiDateRangeFilter(event, key, subKey, 'multiRangeInvDateFilterOption');
  }

  handleMultInvRangeDateFilter() {
    // if(this.filter.multiInvDate.selected.length){
    this.whichFilterApplied('multiRangeInvDate');
    this.filterChange.emit(this.filter);
    this.closeAfterAction = !this.closeAfterAction;
    // }
  }

  validateMultiDateRangeFilter(event: any, key: string, subKey: string, filterName: string) {
    if (subKey === 'startDate') {
      this[filterName]?.endDate?.forEach((item: any) => {
        if (item.id <= event.id) {
          item.isChecked = false;
          item.isInActive = true;
          if (this.filter[key]['endDate'] && this.filter[key]['endDate']?.id <= event.id) {
            delete this.filter[key]['endDate'];
          }
        } else {
          item.isInActive = false;
        }
      });
    }
  }

  changeMultiRORangeDateFilter(event: any, key: string, subKey: string) {
    if (!this.filter[key]) this.filter[key] = {};
    this.filter[key][subKey] = event;
    this.validateMultiDateRangeFilter(event, key, subKey, 'multiRangeRODateFilterOption');
  }

  handleMultiRORangeDateFilter() {
    // if(this.filter.multiInvDate.selected.length){
    this.whichFilterApplied('multiRangeRODate');
    this.filterChange.emit(this.filter);
    this.closeAfterAction = !this.closeAfterAction;
    // }
  }

  changeServiceCategoriesFilter(event: any) {
    if (!this.filter.serviceCategories) {
      this.filter.serviceCategories = { selected: [] };
    }

    this.filter.serviceCategories.selected = event;
    this.closeAfterAction = !this.closeAfterAction;
    this.whichFilterApplied('serviceCategories');
    this.filterChange.emit(this.filter);
  }

  onValueChange(type: string, key: string, value: any) {
    this.filter[type][key] = value;
    this.closeAfterAction = !this.closeAfterAction;
    this.whichFilterApplied(type);
    this.filterChange.emit(this.filter);
  }

  clearMultipleGenericFilter(key: string) {
    if (this.options.multipleGenericFilters) {
      this.multipleGenericFiltersObject[key].selected = [];
      this.multipleGenericFiltersObject[key].filterApplied = this.multipleGenericFiltersObject[key].selected && this.multipleGenericFiltersObject[key].selected.length > 0;
      this.multipleGenericFiltersObject[key].data = this.multipleGenericFiltersObject[key].data.map((item) => ({
        ...item,
        isChecked: false,
      }));
      this.filterChange.emit(this.multipleGenericFiltersObject);
    }
  }

  clearFilter(type: string = '') {
    switch (type) {
      case 'tags':
        this.defalutTags.map((tag) => (tag.isChecked = false));
        this.tags = this.helperService.deepCopy(this.defalutTags);
        this.filter.tags.selected = [];
        break;

      case 'tenantFeature':
        this.tenantFeature = this.helperService.deepCopy(this.defalutTenantFeature);
        this.featureFilter.tenantFeature.selected = [];
        this.filter.tenantFeatureSelected = [];
        break;

      case 'tenantBetaFlagFeature':
        this.tenantBetaFlagFeature = this.helperService.deepCopy(this.defalutTenantBetaFeature);
        this.featureFilter.tenantBetaFlagFeature.selected = [];
        this.filter.tenantBetaFeatureSelected = [];
        break;

      case 'status':
        this.filter.status = {
          active: false,
          inActive: false,
        };
        break;

      case 'pricingLogs':
        this.filter.pricingLogs = {
          company: false,
          matrix: false,
        };
        break;

      case 'tireStoragestatus':
        this.filter.tireStoragestatus = {
          inStorage: false,
          returned: false,
        };
        break;

      case 'tireStorageFilterStatus':
        this.filter.tireStorageFilterStatus = {
          inStorage: false,
          removed: false,
        };
        break;

      case 'tireStorageSeasonality':
        this.filter.tireStorageSeasonality = {
          summer: false,
          winter: false,
        };
        break;

      case 'customerFleet':
        this.filter.customerFleet = {
          regular: false,
          fleet: false,
        };
        break;

      case 'poType':
        this.filter.poType = {
          active: false,
          inActive: false,
        };
        break;

      case 'restockLevel':
        this.filter.restockLevel = {
          active: false,
          inActive: false,
        };
        break;

      case 'language':
        this.filter.language = {
          en: false,
          fr: false
        }
        break;
      case 'stock':
        this.filter.stock = {
          active: false,
          inActive: false,
        };
        break;
      case 'supplierStatus':
        this.filter.supplierStatus = {
          internal: false,
          online: false,
        };
        break;
      case 'appliedOn':
        this.filter.appliedOn = {
          orderLevel: false,
          serviceLevel: false,
        };
        break;
      case 'discountType':
        this.filter.discountType = {
          percentage: false,
          dollarValue: false,
        };
        break;
      case 'poStatus':
        this.filter.poStatus = '';
        break;
      case 'poItemType':
        this.filter.poItemType = '';
        break;
      case 'payableStatus':
        this.filter.payableStatus = '';
        break;
      case 'paymentStatus':
        this.filter.paymentStatus = '';
        break;
      case 'itemType':
        this.filter.itemType = '';
        break;
      case 'categoryType':
        this.filter.categoryType = '';
        break;
      case 'paymentPayableStatus':
        this.filter.paymentPayableStatus = '';
        break;
      case 'returnPart':
        this.filter.returnPart = '';
        break;
      case 'categoryItemType':
        this.filter.categoryItemType = '';
        break;
      case 'location':
        this.filter.location = {
          selected: [],
        };
        this.locations = this.locations.map((loc) => ({
          ...loc,
          isChecked: false,
        }));
        break;

      case 'preffLocations':
        this.filter.preffLocations = {
          selected: [],
        };
        this.preffLocations = this.preffLocations.map((loc) => ({
          ...loc,
          isChecked: false,
        }));
        break;

      case 'supplier':
        this.filter.supplier = {
          selected: [],
        };
        this.suppliers = this.suppliers.map((supplier) => ({
          ...supplier,
          isChecked: false,
        }));
        break;

      case 'columns':
        this.filter.columns = {
          selected: [],
        };
        this.columns = this.columns.map((column) => ({
          ...column,
          isChecked: false,
        }));
        break;

      case 'coreStatus':
        this.filter.coreStatus = {
          selected: [],
        };
        this.coreList = this.coreList.map((core) => ({
          ...core,
          isChecked: false,
        }));
        break;

      case 'returnStatus':
        this.filter.returnStatus = {
          selected: [],
        };
        this.returnList = this.returnList.map((supplier) => ({
          ...supplier,
          isChecked: false,
        }));
        break;

      case 'serviceAuthStatus':
        this.filter.serviceAuthStatus = { selected: [] };
        this.serviceAuthOption = this.serviceAuthOption.map((serviceAuth: any) => {
          serviceAuth.isChecked = false;

          return serviceAuth;
        });
        break;

      case 'multiInvDate':
        this.filter.multiInvDate = { selected: [] };
        this.multiInvoiceDateFilterOption = this.multiInvoiceDateFilterOption.map((invDate: any) => {
          invDate.isChecked = false;

          return invDate;
        });
        break;

      case 'multiROcreatedDate':
        this.filter.multiROcreatedDate = { selected: [] };
        this.multiRODateFilterOption = this.multiRODateFilterOption.map((roDate: any) => {
          roDate.isChecked = false;
          return roDate;
        });
        break;

      case 'multiRangeInvDate':
        this.filter.multiRangeInvDate = { startDate: null, endDate: null };
        break;

      case 'multiRangeRODate':
        this.filter.multiRangeRODate = { startDate: null, endDate: null };
        break;

      case 'serviceCategories':
        this.filter.serviceCategories.selected = [];
        this.serviceCategories = this.helperService.deepCopy(this.defaultServiceCategories);
        break;

      case 'dayFilterOption':
        this.filter.date = { startDate: null, endDate: null };
        this.filterTitle.dayFilterOption = 'Service date';
        break;

      case 'serviceDate':
        this.filter.serviceDate = { startDate: null, endDate: null };
        this.filterTitle.serviceDate = 'Service date';
        break;

      case 'removalDateOption':
        this.filter.removalDateOption = { startDate: null, endDate: null };
        this.filterTitle.removalDateOption = 'Return date';
        break;
      case 'storageDateOption':
        this.filter.storageDateOption = { startDate: null, endDate: null };
        this.filterTitle.storageDateOption = 'Storage date';
        break;
      case 'scheduledReturnDateOption':
        this.filter.scheduledReturnDateOption = { startDate: null, endDate: null };
        this.filterTitle.scheduledReturnDateOption = 'Schedule Return date';
        break;
      case 'roCreateAtFilterOption':
        this.filter.roCreateAtFilterOption = { startDate: null, endDate: null };
        this.filterTitle.roCreateAtFilterOption = 'RO created date';
        break;

      case 'invoiceDateFilterOption':
        this.filter.invoiceDateFilterOption = {
          startDate: null,
          endDate: null,
        };
        this.filterTitle.invoiceDateFilterOption = 'RO invoice date';
        break;

      case 'authorization':
        this.filter.authorization = { approved: false, notApproved: false };
        break;

      case 'tenantType':
        this.resetTenantTypeFilters();
        break;

      case 'tenantStatus':
        this.resetTenantStatusFilters();
        break;
      case 'genericFilter':
        this.filter.genericFilter = {
          selected: [],
        };
        this.genericFilterData = this.genericFilterData.map((data) => ({
          ...data,
          isChecked: false,
        }));
        break;
    }

    this.filterApplied[type] = false;
    this.filterChange.emit(this.filter);
  }

  whichFilterApplied(type: string = '') {
    const {
      tags = {},
      supplier = {},
      location = {},
      preffLocations = {},
      customerFleet = {},
      serviceAuthStatus = {},
      serviceCategories = {},
      tireStoragestatus = {},
      tireStorageFilterStatus = {},
      tireStorageSeasonality = {},
      columns = {},
      multiInvDate = {},
      multiROcreatedDate = {},
      multiRangeInvDate = {},
      multiRangeRODate = {},
    } = this.filter;

    switch (type) {
      case 'tags':
        this.filterApplied.tags = !!(tags && tags.selected && tags.selected.length);
        break;

      case 'tireStoragestatus':
        this.filterApplied.tireStoragestatus = tireStoragestatus.inStorage || tireStoragestatus.returned;
        break;
      
      case 'tireStorageFilterStatus':
        this.filterApplied.tireStorageFilterStatus = tireStorageFilterStatus.inStorage || tireStorageFilterStatus.removed;
        break;
      
      case 'tireStorageSeasonality':
        this.filterApplied.tireStorageSeasonality = tireStorageSeasonality.summer || tireStorageSeasonality.winter;
        break;

      case 'tenantFeature':
        this.filterApplied.tenantFeature = !!(this.featureFilter.tenantFeature && this.featureFilter.tenantFeature.selected && this.featureFilter.tenantFeature.selected.length);
        break;
      case 'tenantBetaFlagFeature':
        this.filterApplied.tenantBetaFlagFeature = !!(
          this.featureFilter.tenantBetaFlagFeature &&
          this.featureFilter.tenantBetaFlagFeature.selected &&
          this.featureFilter.tenantBetaFlagFeature.selected.length
        );
        break;
      case 'supplier':
        this.filterApplied.supplier = !!(supplier && supplier.selected && supplier.selected.length);
        break;

      case 'columns':
        this.filterApplied.columns = !!(columns && columns.selected && columns.selected.length);
        break;

      case 'serviceCategories':
        this.filterApplied.serviceCategories = !!(serviceCategories && serviceCategories.selected && serviceCategories.selected.length);
        break;

      case 'location':
        this.filterApplied.location = !!(location && location.selected && location.selected.length);
        break;

      case 'preffLocations':
        this.filterApplied.preffLocations = !!(preffLocations && preffLocations.selected && preffLocations.selected.length);
        break;

      case 'serviceAuthStatus':
        this.filterApplied.serviceAuthStatus = !!(serviceAuthStatus && serviceAuthStatus.selected && serviceAuthStatus.selected.length);
        break;

      case 'multiInvDate':
        this.filterApplied.multiInvDate = !!(multiInvDate && multiInvDate.selected && multiInvDate.selected.length);
        break;

      case 'multiROcreatedDate':
        this.filterApplied.multiROcreatedDate = !!(multiROcreatedDate && multiROcreatedDate.selected && multiROcreatedDate.selected.length);
        break;

      case 'multiRangeInvDate':
        this.filterApplied.multiRangeInvDate = !!(multiRangeInvDate && multiRangeInvDate.startDate && multiRangeInvDate.endDate);
        break;

      case 'multiRangeRODate':
        this.filterApplied.multiRangeRODate = !!(multiRangeRODate && multiRangeRODate.startDate && multiRangeRODate.endDate);
        break;

      case 'tenantType':
        this.filterApplied.tenantType = this.isTenantTypeFilterApplied();
        break;

      case 'tenantStatus':
        this.filterApplied.tenantStatus = this.isTenantStatusFilterApplied();
        break;

      case 'returnStatus':
        this.filterApplied.returnStatus = !!(this.filter.returnStatus && this.filter.returnStatus.selected && this.filter.returnStatus.selected.length);
        break;

      default:
        if (this.filter[type] && this.filter[type].active === false && this.filter[type] && this.filter[type].inActive === false) {
          this.filterApplied[type] = false;
        } else {
          this.filterApplied[type] = true;
        }
        break;
    }

    if (!customerFleet || (!customerFleet.regular && !customerFleet.fleet)) {
      this.filterApplied.customerFleet = false;
    } else {
      this.filterApplied.customerFleet = true;
    }

    this.filterApplied.language = (this.filter.language.en !== this.filter.language.fr);
  }

  changeMultipleGenericFilter(key: string, event: any, isMultiple: boolean = true) {
    if (this.options.multipleGenericFilters) {
      if (!isMultiple) {
        this.multipleGenericFiltersObject[key].selected = [];
        this.multipleGenericFiltersObject[key].selected.push(this.helperService.deepCopy(event));
      } else {
        this.multipleGenericFiltersObject[key].selected = this.helperService.deepCopy(event);
      }
      this.multipleGenericFiltersObject[key].filterApplied = this.multipleGenericFiltersObject[key].selected && this.multipleGenericFiltersObject[key].selected.length > 0;
      this.closeAfterAction = !this.closeAfterAction;
      this.filterChange.emit(this.multipleGenericFiltersObject);
    }
  }

  changeTagFilter(key: string, event: any, isMultiple: boolean = false) {
    if (isMultiple) {
      this.filter[key].selected = this.helperService.deepCopy(event);
    } else {
      this.filter[key] = event;
    }
    this.whichFilterApplied(key);
    this.closeAfterAction = !this.closeAfterAction;

    this.filterChange.emit(this.filter);
  }

  changeColumnFilter(key: string, event: any, isMultiple: boolean = false) {
    if (isMultiple) {
      this.filter[key].selected = this.helperService.deepCopy(event);
    } else {
      this.filter[key] = event;
    }
    this.whichFilterApplied(key);
    this.closeAfterAction = !this.closeAfterAction;

    this.filterChange.emit(this.filter);
  }

  /**
   * Check if tenant type filter is applied
   */
  isTenantTypeFilterApplied(): boolean {
    return Object.keys(this.featureFilter.tenantType).filter((key) => this.featureFilter.tenantType[key]).length > 0;
  }

  /**
   * Check if tenant status filter is applied
   */
  isTenantStatusFilterApplied(): boolean {
    return Object.keys(this.featureFilter.tenantStatus).filter((key) => this.featureFilter.tenantStatus[key]).length > 0;
  }

  /**
   * Check if tenant flag filter is applied
   */
  isTenantFlagStatusFilterApplied(): boolean {
    return Object.keys(this.featureFilter.tenantFlagStatus).filter((key) => this.featureFilter.tenantFlagStatus[key]).length > 0;
  }

  /**
   * Reset filters
   */
  resetTenantTypeFilters(): void {
    this.filterApplied.tenantType = false;
    Object.keys(this.featureFilter.tenantType).forEach((key) => {
      this.featureFilter.tenantType[key] = false;
    });
    this.filter.tenantTypeSelected = [];
  }

  resetTenantStatusFilters(): void {
    this.filterApplied.tenantStatus = false;
    Object.keys(this.featureFilter.tenantStatus).forEach((key) => {
      this.featureFilter.tenantStatus[key] = false;
    });
    this.filter.tenantStatusSelected = [];
  }

  /**
   * Get filter keys
   */
  getFilterKeys(filterTypeKey: string): string[] {
    return Object.keys(this.featureFilter[filterTypeKey]);
  }

  /**
   * Get Tenant type filter
   */
  getTenantTypeTitle(): string {
    let title = '';
    Object.keys(this.featureFilter.tenantType).forEach((key) => {
      if (this.featureFilter.tenantType[key]) {
        // check if filter title already applied if yes that means multiple filters applied
        // set all in that case
        if (this.filter.tenantTypeSelected.length === 0) {
          title = this.filterTitle.tenantType.all;
        } else if (this.filter.tenantTypeSelected.length === 1) {
          title = this.filterTitle.tenantType[key];
        } else if (this.filter.tenantTypeSelected.length > 0) {
          title = this.filterTitle.tenantType.all;
        }
      }
    });

    // if no filter title at the end of loop that means no filter is applied
    if (!title) {
      title = this.filterTitle.tenantType.all;
    }
    return title;
  }

  /**
   * Get Tenant status filter
   */
  getTenantStatusTitle(): string {
    let title = '';
    Object.keys(this.featureFilter.tenantStatus).forEach((key) => {
      if (this.featureFilter.tenantStatus[key]) {
        // check if filter title already applied if yes that means multiple filters applied
        // set all in that case
        if (this.filter.tenantStatusSelected.length === 0) {
          title = this.filterTitle.tenantStatus.all;
        } else if (this.filter.tenantStatusSelected.length === 1) {
          title = this.filterTitle.tenantStatus[key];
        } else if (this.filter.tenantStatusSelected.length > 0) {
          title = this.filterTitle.tenantStatus.all;
        }
      }
    });

    // if no filter title at the end of loop that means no filter is applied
    if (!title) {
      title = this.filterTitle.tenantStatus.all;
    }
    return title;
  }

  // get tenantFlag status
  getTenantFlagStatusTitle(): string {
    let title = '';
    Object.keys(this.featureFilter.tenantFlagStatus).forEach((key) => {
      if (this.featureFilter.tenantFlagStatus[key]) {
        // check if filter title already applied if yes that means multiple filters applied
        // set all in that case
        if (this.filter.tenantFlagStatusSelected.length === 0) {
          title = this.filterTitle.tenantFlagStatus.all;
        } else if (this.filter.tenantFlagStatusSelected.length === 1) {
          title = this.filterTitle.tenantFlagStatus[key];
        } else if (this.filter.tenantFlagStatusSelected.length > 0) {
          // title = this.filterTitle.tenantFlagStatus[key];
          title = this.filterTitle.tenantFlagStatus.all;
        }
      }
    });

    // if no filter title at the end of loop that means no filter is applied
    if (!title) {
      title = this.filterTitle.tenantFlagStatus.all;
    }
    return title;
  }

  getPreffredLocation(): void {
    if (!this.filter.preffLocations) {
      this.filter.preffLocations = { selected: [] };
    }

    this.httpService
      .getShopLists()
      .then((data: any) => {
        if (data && data.records.length) {
          this.preffLocations = data.records;

          this.preffLocations.map((item) => {
            item['isChecked'] = false;
            item.name = item.name;
            if (this.filter?.preferredLocations?.length > 0) {
              this.filter.preferredLocations.forEach((i) => {
                if (item._id === i) {
                  item['isChecked'] = true;
                  this.filter.preffLocations.selected.push(item);
                }
              });
              this.whichFilterApplied('preffLocations');
              if (this.filter.preferredLocations.length) {
                this.selectAllPrefLocation[0].isChecked = this.filter.preferredLocations.length === this.preffLocations.length ? true : false;
              }
            }
            return item;
          });
          this.preffLocations = this.preffLocations?.sort((a, b) => (a.name > b.name ? 1 : -1));
        }
      })
      .catch((error) => this.helperService.showToaster('error', error));
  }

  /**
   * Get locations
   */
  getLocations(): void {
    if ((this.options.location && this.options.tireStoragestatus && this.options.storageDateOption && this.options.removalDateOption) || this.options?.concatBins) {
      this.httpService
        .getTireStorageLocation('', this.options?.concatBins)
        .then((locations: any) => {
          if (locations && locations.length) {
            locations.forEach((item) => {
              item['isChecked'] = false;
              item.name = item.nameSort;
              return item;
            });
            if(this.options?.concatBins) {
              let locWithBins : any[] = [];
              locations?.forEach((loc: any) => {
                if(loc?.locationBins && loc?.locationBins?.length) {
                  loc?.locationBins.forEach((bin: any) => {
                    const obj = {
                      ...loc,
                      name: `${loc?.name}-${bin.title}`,
                      _id: `${loc?._id}-${bin._id}`
                    };
                    locWithBins.push(obj);
                  });
                }
              });

              const locWithoutBins: any[] = locations?.filter((loc: any) => { return !(loc?.locationBins && loc.locationBins?.length)}) || [];

              this.locations = [...locWithBins, ...locWithoutBins];
            } else {
              this.locations = locations.sort((a, b) => (a.nameSort > b.nameSort ? 1 : -1));
            }
            
          }
        })
        .catch((error) => this.helperService.showToaster('error', error));
    } else {
      this.httpService
        .getLocation({}, true)
        .then((locations: any) => {
          if (locations.length) {
            locations.forEach((item) => {
              item['isChecked'] = false;
              item.name = item.title;
              return item;
            });
            this.locations = locations.sort((a, b) => (a.title > b.title ? 1 : -1));
            this.defaultLocations = this.helperService.deepCopy(this.locations);
          }
        })
        .catch((error) => this.helperService.showToaster('error', error));
    }
  }

  /**
   * Get locations
   */
  getServiceCategories(): void {
    this.httpService
      .getServiceCategories()
      .then((serviceCategories: any) => {
        if (serviceCategories && serviceCategories.length) {
          serviceCategories.forEach((item) => {
            item['isChecked'] = false;
            if (this.filter.serviceCategories.selected) {
              const found = this.filter.serviceCategories.selected.find((selectedCategory) => selectedCategory._id === item._id);
              if (found) {
                item['isChecked'] = true;
              }
            }
            item.name = item.title;
            return item;
          });
          this.serviceCategories = serviceCategories.sort((a, b) => (a.title > b.title ? 1 : -1));
          this.defaultServiceCategories = this.helperService.deepCopy(this.serviceCategories);
        }
      })
      .catch((error) => this.helperService.showToaster('error', error));
  }

  handleSearchTermChange(event: any) {
    this.searchTermText = event.target.innerText;
  }

  handleAddSearchTerm() {
    if (!this.filter.searchTerms) {
      this.filter.searchTerms = {
        selected: [],
      };
    }

    this.filter.searchTerms.selected.push(this.searchTermText);
    this.searchTermInput.nativeElement.innerHTML = '';
  }

  techNameDisplay() {
    if (!this.filter.tech) {
      // return this.filterTitle.tech.all;
    } else if (this.filter.tech) {
      // return this.techNames([this.filter.tech]);
    }
  }

  onStorageDateFilterSelect(id: string, type?) {
    let startDateTime: any,
      endDateTime: any,
      datetime: any = this.dateService.getCurrentDateTimeTz(this.currentDateTime);

    if (id === 'today') {
      datetime = this.dateService.formatDate(datetime, datetimeFormat.yyymmdd);
      this.filter[type].startDate = datetime;
      this.filter[type].endDate = datetime;
      startDateTime = this.dateService.formatDate(`${datetime}T00:00:00`, datetimeFormat.mmmdyyyy);
      endDateTime = startDateTime;
      this.dateTitle = startDateTime;
      this.filter[type].filterTitle = 'Today';
      this.filterTitle[type] = 'Today';
      this.filter[type].filterTitle = 'Today';
      this.filter[type].dateTitle = startDateTime;
    } else if (id === 'yesterday') {
      datetime = this.dateService.subDaysInDatetime(datetime, 1, this.momentPeriod.day, datetimeFormat.yyymmdd);
      this.filter[type].startDate = datetime;
      this.filter[type].endDate = datetime;
      this.filterTitle[type] = 'Yesterday';
      this.filter[type].filterTitle = 'Yesterday';
      this.filter[type].filterTitle = 'Yesterday';
      startDateTime = this.dateService.formatDate(`${datetime}T00:00:00`, datetimeFormat.mmmdyyyy);
      endDateTime = startDateTime;
      this.dateTitle = startDateTime;
      this.filter[type].dateTitle = startDateTime;
    } else if (id === 'tomorrow') {
      datetime = this.dateService.addDaysInDatetime(datetime, 1, this.momentPeriod.day, datetimeFormat.yyymmdd);
      this.filter[type].startDate = datetime;
      this.filter[type].endDate = datetime;
      this.filterTitle[type] = 'Tomorrow';
      this.filter[type].filterTitle = 'Tomorrow';
      startDateTime = this.dateService.formatDate(`${datetime}T00:00:00`, datetimeFormat.mmmdyyyy);
      endDateTime = startDateTime;
      this.dateTitle = startDateTime;
      this.filter[type].dateTitle = startDateTime;
    } else if (id === 'this-week') {
      this.filter[type].startDate = this.dateService.getStartOfThisWeek(datetime, datetimeFormat.yyymmdd);
      this.filter[type].endDate = this.dateService.getEndOfThisWeek(datetime, datetimeFormat.yyymmdd);
      startDateTime = this.dateService.formatDate(`${this.filter[type].startDate}T00:00:00`, datetimeFormat.mmmdyyyy);
      endDateTime = this.dateService.formatDate(`${this.filter[type].endDate}T00:00:00`, datetimeFormat.mmmdyyyy);

      this.dateTitle = this.dateService.formatDateRange(startDateTime, endDateTime);
      this.filter[type].dateTitle = this.dateService.formatDateRange(startDateTime, endDateTime);
      this.filterTitle[type] = 'This week';
      this.filter[type].filterTitle = 'This week';
    } else if (id === 'last-week') {
      datetime = this.dateService.subDaysInDatetime(datetime, 1, 'isoWeek', datetimeFormat.yyymmdd);
      this.filter[type].startDate = this.dateService.getStartOfThisWeek(`${datetime}T00:00:00`, datetimeFormat.yyymmdd);
      this.filter[type].endDate = this.dateService.getEndOfThisWeek(`${datetime}T00:00:00`, datetimeFormat.yyymmdd);
      startDateTime = this.dateService.formatDate(`${this.filter[type].startDate}T00:00:00`, datetimeFormat.mmmdyyyy);
      endDateTime = this.dateService.formatDate(`${this.filter[type].endDate}T00:00:00`, datetimeFormat.mmmdyyyy);
      this.dateTitle = this.dateService.formatDateRange(startDateTime, endDateTime);
      this.filter[type].dateTitle = this.dateService.formatDateRange(startDateTime, endDateTime);
      this.filterTitle[type] = 'Last week';
      this.filter[type].filterTitle = 'Last week';
    } else if (id === 'next-week') {
      datetime = this.dateService.addDaysInDatetime(datetime, 1, 'isoWeek', datetimeFormat.yyymmdd);
      this.filter[type].startDate = this.dateService.getStartOfThisWeek(`${datetime}T00:00:00`, datetimeFormat.yyymmdd);
      this.filter[type].endDate = this.dateService.getEndOfThisWeek(`${datetime}T00:00:00`, datetimeFormat.yyymmdd);
      startDateTime = this.dateService.formatDate(`${this.filter[type].startDate}T00:00:00`, datetimeFormat.mmmdyyyy);
      endDateTime = this.dateService.formatDate(`${this.filter[type].endDate}T00:00:00`, datetimeFormat.mmmdyyyy);
      this.dateTitle = this.dateService.formatDateRange(startDateTime, endDateTime);
      this.filterTitle[type] = 'Next week';
      this.filter[type].dateTitle = this.dateService.formatDateRange(startDateTime, endDateTime);
      this.filter[type].filterTitle = 'Next week';
    }
    else if (id === 'this-month') {
      this.filter[type].startDate = this.dateService.getStartOfThisMonth(datetime, datetimeFormat.yyymmdd);
      this.filter[type].endDate = this.dateService.getEndOfThisMonth(datetime, datetimeFormat.yyymmdd);
      startDateTime = this.dateService.formatDate(`${this.filter[type].startDate}T00:00:00`, datetimeFormat.mmmdyyyy);
      endDateTime = this.dateService.formatDate(`${this.filter[type].endDate}T00:00:00`, datetimeFormat.mmmdyyyy);
      this.dateTitle = this.dateService.formatDate(startDateTime, datetimeFormat.mmmyyyy);
      this.filter[type].dateTitle = this.dateService.formatDateRange(startDateTime, endDateTime);
      this.filterTitle[type] = 'This month';
      this.filter[type].filterTitle = 'This month';
    } else if (id === 'last-month') {
      datetime = this.dateService.subDaysInDatetime(datetime, 1, 'month', datetimeFormat.yyymmdd);
      this.filter[type].startDate = this.dateService.getStartOfThisMonth(datetime, datetimeFormat.yyymmdd);
      this.filter[type].endDate = this.dateService.getEndOfThisMonth(datetime, datetimeFormat.yyymmdd);
      startDateTime = this.dateService.formatDate(`${this.filter[type].startDate}T00:00:00`, datetimeFormat.mmmdyyyy);
      endDateTime = this.dateService.formatDate(`${this.filter[type].endDate}T00:00:00`, datetimeFormat.mmmdyyyy);
      this.dateTitle = this.dateService.formatDate(startDateTime, datetimeFormat.mmmyyyy);
      this.filter[type].dateTitle = this.dateService.formatDateRange(startDateTime, endDateTime);
      this.filterTitle[type] = 'Last month';
      this.filter[type].filterTitle = 'Last month';
    }else if (id === 'next-month') {
      datetime = this.dateService.addDaysInDatetime(datetime, 1, 'month', datetimeFormat.yyymmdd);
      this.filter[type].startDate = this.dateService.getStartOfThisMonth(datetime, datetimeFormat.yyymmdd);
      this.filter[type].endDate = this.dateService.getEndOfThisMonth(datetime, datetimeFormat.yyymmdd);
      startDateTime = this.dateService.formatDate(`${this.filter[type].startDate}T00:00:00`, datetimeFormat.mmmdyyyy);
      endDateTime = this.dateService.formatDate(`${this.filter[type].endDate}T00:00:00`, datetimeFormat.mmmdyyyy);
      this.dateTitle = this.dateService.formatDate(startDateTime, datetimeFormat.mmmyyyy);
      this.filter[type].dateTitle = this.dateService.formatDateRange(startDateTime, endDateTime);
      this.filterTitle[type] = 'Next month';
      this.filter[type].filterTitle = 'Next month';
    } else if (id === 'year-to-date') {
      this.filter[type].startDate = this.dateService.getStartOfThisYear(datetime, datetimeFormat.yyymmdd);
      this.filter[type].endDate = this.dateService.formatDate(datetime, datetimeFormat.yyymmdd);
      startDateTime = this.dateService.formatDate(`${this.filter[type].startDate}T00:00:00`, datetimeFormat.mmmdyyyy);
      endDateTime = this.dateService.formatDate(`${this.filter[type].endDate}T00:00:00`, datetimeFormat.mmmdyyyy);
      this.dateTitle = this.dateService.formatDateRange(startDateTime, endDateTime);
      this.filter[type].dateTitle = this.dateService.formatDateRange(startDateTime, endDateTime);
      this.filterTitle[type] = 'Year to date';
      this.filter[type].filterTitle = 'Year to date';
    } else if (id === 'all-time') {
      this.filter[type].startDate = '2000-01-01';
      this.filter[type].endDate = this.dateService.formatDate(datetime, datetimeFormat.yyymmdd);
      this.dateTitle = 'All time';
      this.filter[type].dateTitle = 'All time';
      this.filterTitle[type] = 'All time';
      this.filter[type].filterTitle = 'All time';
    } else if (id === 'custom') {
      /*
      Every time when we select custom date so it selected the current month date.
      */
      if (this.filter[type].filterTitle !== 'Custom') {
        this.filter[type].startDate = this.dateService.getStartOfThisMonth(datetime, datetimeFormat.yyymmdd);
        this.filter[type].endDate = this.dateService.formatDate(datetime, datetimeFormat.yyymmdd);
      }

      const ref = this.dialogService.open(GroupDatePickerDialogComponent, {
        styleClass: 'add-dialog group-date-picker-dialog',
        showHeader: false,
        data: { ...this.filter[type], currentDate: this.currentDateTime },
      });

      const onClose = ref.onClose.subscribe(({ isSuccess, startDate, endDate }) => {
        if (isSuccess) {
          this.filter[type].startDate = this.dateService.formatDate(`${startDate}T00:00:00`, datetimeFormat.yyymmdd);
          this.filter[type].endDate = this.dateService.formatDate(`${endDate}T00:00:00`, datetimeFormat.yyymmdd);
          startDateTime = this.dateService.formatDate(`${this.filter[type].startDate}T00:00:00`, datetimeFormat.mmmdyyyy);
          endDateTime = this.dateService.formatDate(`${this.filter[type].endDate}T00:00:00`, datetimeFormat.mmmdyyyy);
          this.dateTitle = this.dateService.formatDateRange(startDateTime, endDateTime);
          this.filter[type].dateTitle = this.dateService.formatDateRange(startDateTime, endDateTime);
          this.closeAfterAction = !this.closeAfterAction;
          this.filterChange.emit(this.filter);
        }
        onClose.unsubscribe();
      });

      this.filterTitle[type] = 'Custom';
      this.filter[type].filterTitle = 'Custom';
    } else if (id === 'passed-day') {
      this.dateTitle = this.dateService.formatDate(`${this.filter[type].startDate}T00:00:00`, datetimeFormat.mmmdyyyy);
      this.filter[type].dateTitle = this.dateService.formatDate(`${this.filter[type].startDate}T00:00:00`, datetimeFormat.mmmdyyyy);
      this.filterTitle[type] = this.dateTitle;
      this.filter[type].filterTitle = this.dateTitle;
      return;
    }

    this.filterApplied[type] = id;

    if (this.filterApplied[type] !== 'custom') {
      this.closeAfterAction = !this.closeAfterAction;
      this.filterChange.emit(this.filter);
    }
  }

  print() {
    this.onPrint.emit();
  }
}
